import { render, staticRenderFns } from "./update-pwd.vue?vue&type=template&id=e5b263c2&scoped=true"
import script from "./update-pwd.vue?vue&type=script&lang=js"
export * from "./update-pwd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5b263c2",
  null
  
)

export default component.exports